import { Component, OnInit } from "@angular/core";
import { RegexEnum } from "./../../../../../views/regex.enum";
import { TestService } from "../../../../../views/services/test.service";
import { ParagraphsService } from "../../services/paragraphs.service";

@Component({
  templateUrl: "./paragraphs.component.html",
  styleUrls: ["./paragraphs.component.css"]
})
export class ParagraphsComponent implements OnInit {
  public paragraphs: any;
  public popUpType: string;
  public testId: any;
  public tests: any;
  public paragraph: any = {};
  public display = "none";
  public msg: string = "";
  public displayOrderErr: string = "";
  public paragraphNmErr: string = "";
  public paragraphDsErr: string = "";
  public paragraphTxErr: string = "";
  public statusErr: string = "";
  public statusCode: any = [];
  public oldDisplayNumber: number;
  constructor(
    private paragraphsService: ParagraphsService,
    private testService: TestService
  ) {}

  ngOnInit() {
    this.statusCode = [
      { id: "A", code: "Active" },
      { id: "I", code: "Inactive" },
      { id: "", code: "Please Select" }
    ];
    this.resetForm();
    this.testService.getTest().subscribe(test => {
      this.testId = test[0].TEST_ID;
      this.tests = test;
      this.getParagraph(this.testId, "");
    });
  }

  getParagraph(testId, popup) {
    this.testId = testId;
    this.paragraphsService.getParagraphs(this.testId).subscribe(resp => {
      this.paragraphs = resp;
      if (popup === "close") {
        this.display = "none";
      }
    });
  }

  onSelectTestId() {
    this.msg = "";
    this.getParagraph(this.testId, "");
  }

  openPopUp(item: any, type: string) {
    this.paragraph.TEST_ID = this.testId;
    this.popUpType = type;
    if (this.popUpType === "Edit") {
      this.paragraph.STATUS_CD = item.STATUS_CD;
      this.paragraph.PARAGRAPH_ID = item.PARAGRAPH_ID;
      this.paragraph.DISPLAY_ORDER_NO = item.DISPLAY_ORDER_NO;
      this.paragraph.PARAGRAPH_TX = item.PARAGRAPH_TX;
      this.paragraph.PARAGRAPH_DS = item.PARAGRAPH_DS;
      this.paragraph.PARAGRAPH_NM = item.PARAGRAPH_NM;
      this.oldDisplayNumber = item.DISPLAY_ORDER_NO;
      if (this.paragraph.STATUS_CD === "Inactive") {
        this.paragraph.STATUS_CD = "I";
      } else if (this.paragraph.STATUS_CD === "Active") {
        this.paragraph.STATUS_CD = "A";
      } else if (this.paragraph.STATUS_CD === "Draft") {
        this.paragraph.STATUS_CD = "";
      }
    } else {
      this.paragraph.DISPLAY_ORDER_NO = null;
      this.paragraph.PARAGRAPH_DS = "";
      this.paragraph.PARAGRAPH_NM = "";
      this.paragraph.PARAGRAPH_TX = "";
      this.paragraph.STATUS_CD = "";
    }

    this.display = "block";
  }

  closePopUpForm() {
    this.resetForm();
    this.display = "none";
  }
  save() {
    if (this.popUpType === "Add") {
      this.addRow();
    } else if (this.popUpType === "Edit") {
      this.editRow();
    }
  }

  addRow() {
    let addRow: boolean = false;
    addRow = this.validateAddForm();
    if (addRow) {
      this.paragraphsService.addParagraph(this.paragraph).subscribe(
        resp => {
          if (resp) {
            this.msg = "Paragraph has been added successfully.";
            this.getParagraph(this.testId, "close");
          }
        },
        err => {
          if (err.error.error.message.includes("PARAGRAPH_NM")) {
            this.paragraphNmErr = "Paragraph Code is not valid";
          } else if (err.error.error.message.includes("PARAGRAPH_DS")) {
            this.paragraphDsErr = "Paragraph Description is not valid";
          } else if (err.error.error.message.includes("PARAGRAPH_TX")) {
            this.paragraphTxErr = "Paragraph is not valid";
          } else if (err.error.error.message.includes("DISPLAY_ORDER_NO")) {
            this.displayOrderErr = "Display Order No is not Valid";
          } else {
            this.paragraphNmErr = "Paragraph code must be unique";
          }
        }
      );
    }
  }

  validateAddForm() {
    const emptyOrOnlyWhiteSpace = new RegExp(RegexEnum.EMPTY_OR_WHITESPACE);
    if (!this.paragraph.DISPLAY_ORDER_NO) {
      this.displayOrderErr = "Display Order No is required";
    } else {
      if (this.paragraph.DISPLAY_ORDER_NO && this.paragraphs.length > 0) {
        this.paragraph.DISPLAY_ORDER_NO = Number(
          this.paragraph.DISPLAY_ORDER_NO
        );
        const duplicateNumber = this.paragraphs.some(
          item => item.DISPLAY_ORDER_NO === this.paragraph.DISPLAY_ORDER_NO
        );
        if (duplicateNumber) {
          this.displayOrderErr = "Display Order must be unique within Test";
        } else {
          this.displayOrderErr = "";
        }
      } else {
        this.displayOrderErr = "";
      }
    }

    if (this.paragraph.PARAGRAPH_DS) {
      const regex = new RegExp(RegexEnum.PARAGRAPH_DS_PATTERN);
      if (regex.test(this.paragraph.PARAGRAPH_DS)) {
        this.paragraphDsErr = "";
      } else {
        this.paragraphDsErr = "Paragraph Description is not valid";
      }
    } else {
      this.paragraphDsErr = "";
    }

    if (
      !this.paragraph.PARAGRAPH_NM ||
      this.paragraph.PARAGRAPH_NM === "" ||
      this.paragraph.PARAGRAPH_NM === null
    ) {
      this.paragraphNmErr = "Paragraph code is required";
    } else {
      if (emptyOrOnlyWhiteSpace.test(this.paragraph.PARAGRAPH_NM)) {
        const regex = new RegExp(RegexEnum.PARAGRAPH_NM_PATTERN);
        if (regex.test(this.paragraph.PARAGRAPH_NM)) {
          this.paragraphNmErr = "";
        } else {
          this.paragraphNmErr = "Paragraph Code is not valid";
        }
      } else {
        this.paragraphNmErr = "Paragraph code is required";
      }
    }

    if (this.paragraph.STATUS_CD) {
      this.statusErr = "";
    } else {
      this.statusErr = "Please Select a status";
    }
    if (
      !this.paragraph.PARAGRAPH_TX ||
      this.paragraph.PARAGRAPH_TX === "" ||
      this.paragraph.PARAGRAPH_TX === null
    ) {
      this.paragraphTxErr = "Paragraph is required";
    } else {
      if (emptyOrOnlyWhiteSpace.test(this.paragraph.PARAGRAPH_TX)) {
        const regex = new RegExp(RegexEnum.PARAGRAPH_TX_PATTERN);
        if (regex.test(this.paragraph.PARAGRAPH_TX)) {
          this.paragraphTxErr = "";
        } else {
          this.paragraphTxErr = "Paragraph is not valid";
        }
      } else {
        this.paragraphTxErr = "Paragraph is required";
      }
    }
    if (
      this.paragraphTxErr ||
      this.paragraphNmErr ||
      this.paragraphDsErr ||
      this.statusErr ||
      this.displayOrderErr
    ) {
      return false;
    } else {
      return true;
    }
  }
  editRow() {
    let editRow: boolean = false;
    editRow = this.validateEditForm();
    if (editRow) {
      this.paragraphsService.editParagraph(this.paragraph).subscribe(
        response => {
          if (response) {
            this.msg = "All your changes have been saved.";
            this.getParagraph(this.testId, "close");
          }
        },
        err => {
          if (err.error.error.message.includes("PARAGRAPH_DS")) {
            this.paragraphDsErr = "Paragraph Description is not valid";
          } else if (err.error.error.message.includes("PARAGRAPH_TX")) {
            this.paragraphTxErr = "Paragraph is not valid";
          } else if (err.error.error.message.includes("DISPLAY_ORDER_NO")) {
            this.displayOrderErr = "Display Order No is not Valid";
          }
        }
      );
    }
  }

  validateEditForm() {
    const emptyOrOnlyWhiteSpace = new RegExp(RegexEnum.EMPTY_OR_WHITESPACE);
    if (!this.paragraph.DISPLAY_ORDER_NO) {
      this.displayOrderErr = "Display Order No is required";
    } else {
      if (this.paragraph.DISPLAY_ORDER_NO && this.paragraphs.length > 0) {
        this.paragraph.DISPLAY_ORDER_NO = Number(
          this.paragraph.DISPLAY_ORDER_NO
        );
        if (this.oldDisplayNumber !== this.paragraph.DISPLAY_ORDER_NO) {
          const duplicateNumber = this.paragraphs.some(
            item => item.DISPLAY_ORDER_NO === this.paragraph.DISPLAY_ORDER_NO
          );
          if (duplicateNumber) {
            this.displayOrderErr = "Display Order must be unique within Test";
          } else {
            this.displayOrderErr = "";
          }
        } else {
          this.displayOrderErr = "";
        }
      } else {
        this.displayOrderErr = "";
      }
    }

    if (this.paragraph.PARAGRAPH_DS) {
      const regex = new RegExp(RegexEnum.PARAGRAPH_DS_PATTERN);
      if (regex.test(this.paragraph.PARAGRAPH_DS)) {
        this.paragraphDsErr = "";
      } else {
        this.paragraphDsErr = "Paragraph Description is not valid";
      }
    } else {
      this.paragraphDsErr = "";
    }

    if (this.paragraph.STATUS_CD) {
      this.statusErr = "";
    } else {
      this.statusErr = "Please Select a status";
    }
    if (
      !this.paragraph.PARAGRAPH_TX ||
      this.paragraph.PARAGRAPH_TX === "" ||
      this.paragraph.PARAGRAPH_TX === null
    ) {
      this.paragraphTxErr = "Paragraph is required";
    } else {
      if (emptyOrOnlyWhiteSpace.test(this.paragraph.PARAGRAPH_TX)) {
        const regex = new RegExp(RegexEnum.PARAGRAPH_TX_PATTERN);
        if (regex.test(this.paragraph.PARAGRAPH_TX)) {
          this.paragraphTxErr = "";
        } else {
          this.paragraphTxErr = "Paragraph is not valid";
        }
      } else {
        this.paragraphTxErr = "Paragraph is required";
      }
    }
    if (
      this.paragraphTxErr ||
      this.paragraphDsErr ||
      this.statusErr ||
      this.displayOrderErr
    ) {
      return false;
    } else {
      return true;
    }
  }

  resetForm() {
    this.msg = "";
    this.paragraphDsErr = "";
    this.paragraphNmErr = "";
    this.statusErr = "";
    this.displayOrderErr = "";
    this.paragraphTxErr = "";
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/accmgr/ba/Paragraphs/paragraphs.component.ts